import fetchYesObjects from 'yesObject/shared/api/fetchYesObjects'

const verifySelectedRelationsLinked = async ({
  objectclassUuid,
  relationCounterpartColumn,
  mainObjectUuid,
  selectedUuids
}: {
  objectclassUuid: string
  relationCounterpartColumn: string
  mainObjectUuid: string
  selectedUuids: string[]
}): Promise<boolean> => {
  if (!selectedUuids.length) {
    return true
  }

  const { objects } = await fetchYesObjects({
    filterBody: {
      objectclass: objectclassUuid,
      data_storage: '',
      query: {
        $and: [
          { uuid: { $in: selectedUuids } },
          { [`${relationCounterpartColumn}.uuid`]: { $in: [mainObjectUuid] } },
          { 'situation.des': { $gte: '40' } }
        ]
      },
      pagination: { limit: selectedUuids.length, offset: 0 },
      orderby: [{ date_creation_row: 'desc' }]
    },
    showLoading: false
  })

  return (objects?.length ?? 0) === selectedUuids.length
}

export default verifySelectedRelationsLinked
